/********************* TEST ********************/
/*import React from 'react';
import ReactDOM from 'react-dom';*/
/******************** TEST ********************/

import loadCopys from "../../../../base/services/consorcio.i18n";
import Tools from "../../../../base/components/tools";
import ListadoPagosDisponibles from "../../../components/listadoPagosDisponibles/listadoPagosDisponibles";
import PanelPagos from "../../../components/panelPagos/panelPagos";
import CustomModal from "../../../../base/components/modal";

/******************** BUILD ********************/
import less from "../index.less";
/******************** BUILD ********************/

class PagoEmpresarial extends React.Component {
  constructor() {
    super();
    this.state = {
      showError: false,
      allSelected: false,
      open: true,
      showInfoPanel: true,
      pager: {
        currentPage: 1,
        totalPages: 1
      },
      pagerList: {
        currentPage: 1,
        totalPages: 1
      },
      authenticatedUser: {},
      configurations: {},
      typeDocList: [],
      futurePayments: false,
      isDlgParameter: false,
      paylistData: []
    };
    loadCopys("pagosPC/paginaPago/src/text.js");
    this.handleChecked = this.handleChecked.bind(this);
    this.setPage = this.setPage.bind(this);
    this.onSelectKey = this.onSelectKey.bind(this);
    this.tools = new Tools();
    this.getAvailablePaymentsList = this.getAvailablePaymentsList.bind(this);
    this.setTypeDocument = this.setTypeDocument.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.renderGeneralModal = this.renderGeneralModal.bind(this);
    this.sendInfoToPaymentPage = this.sendInfoToPaymentPage.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      const authenticatedUser = compTools.obtenerInformacionUsuario();
      this.setState({ authenticatedUser });
      this.loadParams();
      this.getAvailablePaymentsList(authenticatedUser);
      this.isTokenError();
      this.isDlgParameter();
    }, 500);
  }

  loadParams() {
    const configurations = {};
    this.pnpService = new ServicioPnp();

    this.pnpService.getListWithTop(
      "configuraciones",
      list => {
        list.forEach(item => {
          configurations[item.CSNombreText] = item.CSValorNote;
        });
        this.setState({ configurations });
      },
      500,
      "CSSeccionChoice eq 'Preliquidaci%C3%B3n' or CSSeccionChoice eq 'Texto' or CSSeccionChoice eq 'Novedades' or CSSeccionChoice eq 'Pagos PC'"
    );

    this.pnpService.getListWithTop(
      "parametrosPaginas",
      list => {
        list.forEach(item => {
          configurations[item.CSNombreText] = item.CSValorNote;
          configurations[item.CSNombreText + "CSVisibleBool"] =
            item.CSVisibleBool;
        });
        configurations["toolTipMessage"] = i18next.t("textoHoverCardBoton");

        this.setState({ configurations });
      },
      500,
      "CSFormularioChoice eq 'Pagos PC'"
    );

    this.pnpService.getList(
      "tiposDocumento",
      typeDocList => {
        this.setState({ typeDocList });
        sessionStorage.setItem("typeDocList", JSON.stringify(typeDocList));
      },
      null,
      "CSIdDocumentoText",
      "CSSiglaText",
      "CSDocumentoIdentidadText"
    );
  }
  setTypeDocument() {
    const typeDocList = !!this.state.typeDocList
      ? [...this.state.typeDocList]
      : "";
    const userInfo = !!this.state.authenticatedUser
      ? this.state.authenticatedUser["TipoIdentificacion"]
      : "";
    const type = typeDocList.filter(
      item => item["CSIdDocumentoText"] == userInfo
    );
    const newtype = !!type[0] ? type[0]["CSSiglaText"].toUpperCase() : null;
    return newtype;
  }

  getAvailablePaymentsList(authenticatedUser) {
    if (
      authenticatedUser["TipoIdentificacion"] === undefined ||
      authenticatedUser["LegalID"] === undefined
    ) {
      const authenticatedUserTypeId = sessionStorage.getItem("UserTypeId");
      const authenticatedUserId = sessionStorage.getItem("UserId");
      authenticatedUser["TipoIdentificacion"] = authenticatedUserTypeId;
      authenticatedUser["LegalID"] = authenticatedUserId;
      const getName = new ServicioProxy(
        `ConsultarNombreBeneficiario?tipoDocumento=${authenticatedUserTypeId}&numeroDocumento=${authenticatedUserId}`,
        "ServicioConsorcioTransacciones.svc"
      );
      getName.getElements("POST", {}).then(response => {
        const data = JSON.parse(response);
        const authenticatedUser = this.state.authenticatedUser;
        authenticatedUser["Nombre"] = data.NombreBeneficiario;
        this.setState({ authenticatedUser });
      });
    }

    const query = `ObtenerListadoPagosDisponibles?tipoUsuario=Empresarial&tipoDocumento=${authenticatedUser["TipoIdentificacion"]
      }&numeroDocumento=${authenticatedUser["LegalID"]}&ip=${authenticatedUser["IP"]
      }`;
    //const query = `ObtenerListadoPagosDisponibles?tipoDocumento=2&numeroDocumento=899999086&ip=10.130.168.15`;
    const getList = new ServicioProxy(
      query,
      "ServicioConsorcioTransacciones.svc"
    );
    this.setState(
      prevState => ({ loading: true }),
      () => {
        //console.log("loading ");
      }
    );

    getList
      .getElements("POST", {})
      .then(response => {
        const data = JSON.parse(response);
        if (data.Error && !!data.Error.MensajeError) {
          throw data.Error;
        } else if (data["PagosDisponibles"].length > 0) {
          let disabledFlag = false;
          const futurePayments = data["HabilitarPagosFuturos"];
          const paylistData = data["PagosDisponibles"].map(item => {
            const isSelected = item["Estado"] === "En mora";
            const disabled = disabledFlag;
            if (item["Estado"] !== "En mora") {
              disabledFlag = true;
            }
            return {
              monthName: item["MesCorrespondiente"],
              payExpirationDate: item["FechaVencimiento"],
              paymentState: item["Estado"],
              amountFee: item["ValorCuota"],
              referenceNumber: item["NumeroReferencia"],
              isSelected: isSelected,
              disabled,
              NumeroReferenciaExt: item['NumeroReferenciaExt'],
            };
          });
          const maxItems = 10;
          this.setState(
            prevState => ({
              paylistData,
              allSelected: paylistData.every(el=> el.isSelected),
              futurePayments,
              loading: false,
              pagerList: {
                currentPage: 1,
                totalPages: Math.ceil(paylistData.length / maxItems)
              }
            }),
            () => console.log("")
          );
        }
      })
      .catch(error => {
        this.setState({ showError: true });
      });
  }

  handleChecked(event, isSelectAll, index) {
    const maxItems = 10;
    const futurePayments = this.state.futurePayments;
    const getTotalPages = list =>
      Math.ceil(list.filter(pay => pay.isSelected).length / maxItems);
    const getPaylistData = (value, isSelectAll) => {
      if (isSelectAll) {
        const paylistData = this.state.paylistData.map((month, index) => {
          // const disabledValue = value ? false : index > 0 ? true : false;
          const disabledValue = false
          const lastEnabled =
            index !== 0 &&
            this.state.paylistData[index - 1]["paymentState"] !== "En mora";
          // const disabled =
          //   month["paymentState"] !== "En mora" &&
          //   lastEnabled &&
          //   !futurePayments;
          const disabled = false
          return {
            ...month,
            isSelected: value && !disabled,
            disabled: disabled || disabledValue
          };
        });
        return paylistData;
      } else {
        const paylistData = [...this.state.paylistData];
        paylistData[index].isSelected = value;
        // const disabled =
        //   paylistData[index]["paymentState"] !== "En mora" && !futurePayments;
        const disabled = false
        // if (!value) {
        //   for (let i = index + 1; i < paylistData.length; i++) {
        //     paylistData[i].isSelected = false;
        //     paylistData[i].disabled = true;
        //   }
        // } else if (index + 1 < paylistData.length) {
        //   paylistData[index + 1].disabled = disabled;
        // }
        return paylistData;
      }
    };
    if (event) {
      const target = event.target;
      const value = !!target.checked;
      const allSelectedState = this.state.allSelected;
      const allSelected = (isSelectAll && value) || (allSelectedState && value);
      const oldPager = this.state.pager;
      const paylistData = getPaylistData(value, isSelectAll);
      const totalPages = getTotalPages(paylistData);
      const currentPage =
        totalPages < oldPager.currentPage
          ? totalPages
          : oldPager.currentPage || 1;
      this.setState({
        allSelected,
        paylistData,
        pager: { currentPage, totalPages }
      });
    }
  }

  sendInfoToPaymentPage(e, data) {
    e.preventDefault();
    const userData = this.state.authenticatedUser;
    // const query = `${_spPageContextInfo.webAbsoluteUrl}${this.state.configurations["urlPagos"]
    //   }tipoDocumento=${userData["TipoIdentificacion"]}&numeroDocumento=${userData["LegalID"]
    //   }`;
    const formattedName = this.state.authenticatedUser["Nombre"]
      ? this.state.authenticatedUser["Nombre"].trim()
      : "(No se pudo obtener el nombre)";
    const nameArray = formattedName.split(" ");
    let name1='', name2='', lastn1='', lastn2='';
    if (formattedName == "(No se pudo obtener el nombre)") {
      name1 = "(No se pudo obtener el nombre)";
    } else {
      [name1, name2, lastn1, lastn2] = nameArray;
    }
    const referenceNumber = [];
    data.forEach(referencia => {
      referenceNumber.push(referencia["referenceNumber"]);
    });
    // const formattedReference = referenceNumber.join();
    let valorTotal = data.reduce((acum, act) => acum + act.amountFee, 0);
    valorTotal = valorTotal || 1000;
    const dataToSend = {
      "cliente": {
        "nombre1": name1,
        "nombre2": name2,
        "apellido1": lastn1 || "",
        "apellido2": lastn2 || "",
        "correo_Electronico": "",
        "direccion": "",
        "numero_Identificacion": userData["LegalID"],
        "telefono": "3122200195",
        "tipo_Documento": userData["TipoIdentificacion"]
      },
      "transaccion": {
        "id_Transaccion_Comercio": "",
        "impuesto": "0",
        "moneda": "COP",
        "referencia_Pago": "986421658",
        "valor": valorTotal,
        "valor_Base": "0"
      },
      "medio_Pago": {
        "medio_Pago": this.state.configurations["TransarPcEmpresarial"] || "TRANSAR_PC_EMPRESARIAL",
        "ccv": "",
        "fecha_Expiracion_Tarjeta": "",
        "nombre_En_Tarjeta": "",
        "numero_Tarjeta": "",
        "codigo_Banco": "",
        "franquicia": ""
      },
      "pagador": {
        "apellido1": "",
        "apellido2": "",
        "ciudad": "",
        "correo_Electronico": "",
        "direccion": "",
        "nombre1": "",
        "nombre2": "",
        "numero_Identificacion": "",
        "pais": "",
        "telefono": "",
        "tipo_Cliente": "",
        "tipo_Identificacion": ""
      },
      "cookie_Pagador": "",
      "deviceSessionId": "",
      "idioma": "ES",
      // "iP_Pagador": this.state.IPUser,
      "pais_Pago": "CO",
      "parametrosExtra": [
        {
          nombre: "Referencia",
          valor: data.map((bill) => `${bill.NumeroReferenciaExt}-${bill.amountFee}`).join('|'),
        }
      ],
      // "urL_Redireccion": "http://vmdkansas/eDesarrollo/MiRegistro/Carro/ResultadoPagoProcessa.aspx?TipoPago=TarjetaCompensar",
      "urL_Redireccion": `${_spPageContextInfo.webAbsoluteUrl}${
            this.state.isDlgParameter
              ? this.state.configurations["UrlRetornoServicioPagosNew"] + "?isdlg=1"
              : this.state.configurations["UrlRetornoServicioPagosNew"]
      }`,
      "userAgent_Pagador": ""
    };
    
    const getList = new ServicioProxy(
      'GenerarPagosNew',
      "ServicioConsorcioTransacciones.svc"
    ).getElements("POST", dataToSend);
    getList.then((res) => {
      const parsed = JSON.parse(res);
      console.log({parsed});
      console.log('parsed.eCollectUrl', parsed.eCollectUrl);
      sessionStorage.setItem(
        "InfoPago", // no sé si es InfoPagoRes
        JSON.stringify(parsed)
      );
      sessionStorage.setItem(
        "InfoPagoSent",
        JSON.stringify(dataToSend)
      );
      window.location.href = parsed.eCollectUrl;
    });
  }

  onSelectKey(e) {
    e.preventDefault();
    this.setState({ open: !this.state.open });
  }

  setPage(page, isList = false) {
    const curPager = isList ? this.state.pagerList : this.state.pager;
    const pager = {
      ...curPager,
      currentPage: page,
    };
    this.setState(isList ? { pagerList: pager } : { pager });
  }

  closeAlert() {
    this.setState({ showInfoPanel: false });
  }
  renderGeneralModal() {
    return (
      <CustomModal
        ref="generalModal"
        showModal={true}
        msg={this.state.errorMsg}
      />
    );
  }

  getUrlParameter() {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  }

  isDlgParameter() {
    const isDlg = this.getUrlParameter().isdlg;
    if (!!isDlg) {
      this.setState({ isDlgParameter: true });
    }
  }

  isTokenError() {
    const isToken = this.getUrlParameter().token;
    if (isToken === "null") {
      this.setState({ showError: true });
    }
  }

  render() {
    const renderModal = this.renderGeneralModal;
    const paylistData = this.state.paylistData.map((pay, index) => ({
      ...pay,
      index,
    }));
    const isInDebt = paylistData.some(
      (month) => month.paymentState === "En mora"
    );
    return (
      <div>
        <div className='payment-page'>
          {this.state.showError && renderModal()}
          <div className='main-title text-left notleft-padding notright-padding'>
            <h1 className='title '>{i18next.t("tituloPaginaPago")}</h1>
            <h2 className='payment-description'>
              {this.state.configurations["DescripcionPaginaPagosEmpresa"]}
            </h2>
          </div>
          <div className='payment-user-info'>
            <div className='user-type col-md-4'>
              <p className='bill-query-title'>{i18next.t("empresa")}</p>
              <div className='user-name'>
                <p>
                  {this.state.authenticatedUser["Nombre"]
                    ? this.state.authenticatedUser["Nombre"]
                    : "No se pudo obtener nombre"}
                </p>
              </div>
            </div>
            <div className='user-info col-md-4'>
              <p className='reference-title'>{i18next.t("documento")}</p>
              <p className='reference-number'>{`${this.setTypeDocument() !== null ? this.setTypeDocument() : ""
                } ${this.state.authenticatedUser["LegalID"] !== undefined
                  ? this.state.authenticatedUser["LegalID"]
                  : ""
                }`}</p>
            </div>
          </div>
          <h5 className='title'>
            {this.state.configurations["TituloIntroductorioListadoDePagos"]}
          </h5>
          {isInDebt && this.state.showInfoPanel ? (
            <div className='info-container mobile-info'>
              <div className='icon-container'>
                <i
                  className='fa fa-times-circle close-icon'
                  aria-hidden='true'
                  onClick={this.closeAlert}
                />
                <i className='fa fa-exclamation-circle' aria-hidden='true' />
              </div>
              <p className='col-xs-12 col-sm-10 col-md-11'>
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.state.configurations[
                      "MensajeInformativoPaginaPagosEmpresa"
                    ]
                  }}
                />
              </p>
              <div className='clearfix' />
            </div>
          ) : (
              ""
            )}
          <div className='col-sm-12 col-md-8 panel-detail-left'>
            <ListadoPagosDisponibles
              pagerList={this.state.pagerList}
              setPage={this.setPage}
              paylistData={paylistData}
              handleChecked={this.handleChecked}
              tools={this.tools}
              allSelected={this.state.allSelected}
              configurations={this.state.configurations}
            />
            <div className='row row-bottom' />
          </div>
          <div
            className='col-sm-12 col-md-4 panel-left-summary'
            id='panel-left-summary'
          >
            {isInDebt && this.state.showInfoPanel ? (
              <div className='info-container desktop-info'>
                <div className='icon-container'>
                  <i
                    className='fa fa-times-circle close-icon'
                    aria-hidden='true'
                    onClick={this.closeAlert}
                  />
                  <i className='fa fa-exclamation-circle' aria-hidden='true' />
                </div>
                <p className='col-xs-12 col-sm-10 col-md-11'>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.configurations[
                        "MensajeInformativoPaginaPagosEmpresa"
                      ]
                    }}
                  />
                </p>
                <div className='clearfix' />
              </div>
            ) : (
                ""
              )}
            <PanelPagos
              paylistData={paylistData}
              handleChecked={this.handleChecked}
              pager={this.state.pager}
              setPage={this.setPage}
              onSelectKey={this.onSelectKey}
              open={this.state.open}
              sendInfoToPaymentPage={this.sendInfoToPaymentPage}
            />
          </div>
        </div>
      </div>
    );
  }
}

const MenuItem = ReactBootstrap.MenuItem;
const DropdownButton = ReactBootstrap.DropdownButton;
const Popover = ReactBootstrap.Popover;
const OverlayTrigger = ReactBootstrap.OverlayTrigger;

const appId = document.getElementById("payment-page");
ReactDOM.render(<PagoEmpresarial />, appId);
